import "../assets/Note.css";
import { defineComponent as L, computed as s, openBlock as d, createElementBlock as M, normalizeStyle as z, useCssVars as E, ref as D, createBlock as g, Transition as R, withCtx as U, withDirectives as X, createElementVNode as p, unref as v, normalizeClass as x, createCommentVNode as H, Fragment as F, renderList as j, resolveDynamicComponent as C, mergeProps as q, createVNode as G, vShow as J, watch as Z, onUpdated as tt, onMounted as ot } from "vue";
import { d as y, e as B, a as P, b as S, A as b } from "./maps.DxC18PqJ.js";
import { u as O, b as et } from "./index.AJuLibkw.js";
import { _ as Q } from "./Icon.vue_vue_type_style_index_0_lang.Caqu8YXw.js";
import { _ as W } from "./XClose.vue_vue_type_style_index_0_lang.B6lW8SK8.js";
import { n as N, m as nt, u as at } from "./useStore.CDG6wbfK.js";
import { a as it, _ as st, b as lt, c as dt } from "./Text.vue_vue_type_style_index_0_lang.CqNxQPnN.js";
import { _ as rt } from "./_plugin-vue_export-helper.CHgC5LLL.js";
import { p as K } from "./parseToolData.CdJg7fgv.js";
function $(r, a = y.UpperLeft, t = !0) {
  let e = r;
  switch (a) {
    case y.Top:
      e += "-from-top";
      break;
    case y.Bottom:
      e += "-from-bottom";
      break;
    default:
      e += `-from-${a.slice(-1) === "L" ? "left" : "right"}`;
      break;
  }
  return t || (e += "-no-bounce"), e;
}
const ct = ["innerHTML", "data-module-id"], ut = /* @__PURE__ */ L({
  __name: "Activity",
  props: {
    moduleProps: {}
  },
  setup(r) {
    const a = N(), t = r, e = s(
      () => a == null ? void 0 : a.literals.getActivityLiteral(
        t.moduleProps.textKey,
        a == null ? void 0 : a.extraData.tokens
      )
    ), c = s(() => it(t.moduleProps.appearance, a == null ? void 0 : a.device));
    return (i, T) => (d(), M("div", {
      class: "thn--tool-activity",
      innerHTML: e.value,
      "data-module-id": i.moduleProps.id,
      style: z(c.value)
    }, null, 12, ct));
  }
}), Y = {
  [B.Paragraph]: st,
  [B.Activity]: ut,
  [B.Button]: lt
}, Ct = [
  P.SlideIn
], pt = ["data-position", "data-device", "data-builder-mode", "data-text-direction"], mt = { class: "thn--tool-note__content" }, ft = {
  class: /* @__PURE__ */ x([
    "thn--tool-note__modules"
  ]),
  "data-add-module": !0
}, ht = { class: "thn--tool-note__modules__wrapper" }, I = /* @__PURE__ */ L({
  __name: "SlideIn",
  props: {
    tool: {},
    context: {},
    onHideLayout: {},
    iconProps: {},
    restModules: { default: () => [] },
    layout: {},
    hidden: { type: Boolean, default: !1 }
  },
  setup(r) {
    E((o) => ({
      "35d34870": e.value,
      d877be4a: c.value
    }));
    const a = r, t = N(), e = s(() => t != null && t.rtl ? "none" : "12px"), c = s(() => t != null && t.rtl ? "12px" : "none"), i = D(), { height: T } = O(i), f = s(() => {
      const { position: o } = a.tool.settings.devices[a.context.deviceViewport];
      return o ? $("fade", o) : void 0;
    }), { isSwiping: w, lengthX: n } = et(i, {
      onSwipeEnd: () => {
        Math.abs(n.value) > 150 && (t == null || t.handlers.callHandler(b.Dismiss));
      }
    }), h = s(() => {
      const o = {};
      if (w.value && i.value) {
        const u = -i.value.getBoundingClientRect().width / 2 - n.value;
        o.transform = `translateX(${u}px)`, o.opacity = (100 - Math.abs(n.value / 3)) / 100;
      }
      return {
        ...o
      };
    });
    return (o, u) => (d(), g(R, {
      name: f.value,
      appear: "",
      onAfterLeave: o.onHideLayout
    }, {
      default: U(() => {
        var m;
        return [
          X(p("div", {
            class: "thn--tool thn--tool-note",
            ref_key: "rootDom",
            ref: i,
            style: z(h.value),
            "data-position": o.tool.settings.devices[o.context.deviceViewport].position,
            "data-device": o.context.deviceViewport,
            "data-builder-mode": o.context.builderMode,
            "data-text-direction": (m = v(t)) != null && m.rtl ? "rtl" : "ltr"
          }, [
            u[0] || (u[0] = p("div", { class: "thn--tool-note__back" }, null, -1)),
            p("div", mt, [
              o.iconProps ? (d(), g(Q, {
                key: 0,
                class: x(["thn--tool-note__icon", [v(T) > 72 ? "icon-top" : "icon-center"]]),
                "data-module-id": o.iconProps.id,
                "data-module-special": !0,
                "module-props": o.iconProps
              }, null, 8, ["class", "data-module-id", "module-props"])) : H("", !0),
              p("div", ft, [
                p("div", ht, [
                  (d(!0), M(F, null, j(o.restModules, (_, l) => (d(), g(C(v(Y)[_.moduleType]), q({
                    class: "thn--tool-note-component",
                    key: l,
                    "tool-kind": v(S).Note,
                    ref_for: !0
                  }, {
                    moduleProps: _
                  }), null, 16, ["tool-kind"]))), 128))
                ])
              ])
            ]),
            G(W)
          ], 12, pt), [
            [J, !o.hidden]
          ])
        ];
      }),
      _: 1
    }, 8, ["name", "onAfterLeave"]));
  }
}), _t = ["data-position", "data-content-alignment", "data-text-direction", "data-device"], vt = { class: "thn--tool-note--bar__content" }, yt = {
  class: /* @__PURE__ */ x([
    "thn--tool-note__modules"
  ]),
  "data-add-module": !0
}, gt = { class: "thn--tool-note__modules__wrapper" }, Tt = /* @__PURE__ */ L({
  __name: "Bar",
  props: {
    hidden: { type: Boolean },
    iconProps: {},
    layout: {},
    restModules: {},
    context: {}
  },
  setup(r) {
    E((n) => ({
      "2c685fac": T.value,
      "11f01077": f.value
    }));
    const a = r, t = N(), e = D(), { height: c } = O(e);
    let i;
    const T = s(() => t != null && t.rtl ? "none" : "12px"), f = s(() => t != null && t.rtl ? "12px" : "none"), w = s(() => {
      var n;
      return ((n = a.layout) == null ? void 0 : n.position) === y.Bottom ? $("fade", y.Bottom, !1) : $("fade", y.Top, !1);
    });
    return Z(c, async (n, h) => {
      var o;
      ((o = a.layout) == null ? void 0 : o.position) === y.Top && (h === 0 && n > 0 && (t == null || t.handlers.setDataValidator(
        b.TranslateDocumentBody,
        () => ({ y: c.value || 60 })
      ), i = await (t == null ? void 0 : t.handlers.callHandler(
        b.TranslateDocumentBody
      ))), h > 0 && n === 0 && (i && i(), t == null || t.handlers.setDataValidator(
        b.TranslateDocumentBody,
        () => ({ y: 0 })
      )));
    }), (n, h) => (d(), g(R, {
      name: w.value,
      appear: ""
    }, {
      default: U(() => {
        var o, u, m;
        return [
          X(p("div", {
            class: "thn--tool thn--tool-note--bar",
            ref_key: "rootDom",
            ref: e,
            "data-position": (o = n.layout) == null ? void 0 : o.position,
            "data-content-alignment": (u = n.layout) == null ? void 0 : u.contentAlignment,
            "data-text-direction": (m = v(t)) != null && m.rtl ? "rtl" : "ltr",
            "data-device": n.context.deviceViewport,
            "data-layout-direction": "horizontal"
          }, [
            p("div", vt, [
              n.iconProps ? (d(), g(Q, {
                key: 0,
                class: "thn--tool-note--bar__icon",
                "data-module-id": n.iconProps.id,
                "data-module-special": !0,
                "module-props": n.iconProps
              }, null, 8, ["data-module-id", "module-props"])) : H("", !0),
              p("div", yt, [
                p("div", gt, [
                  (d(!0), M(F, null, j(n.restModules, (_, l) => (d(), g(C(v(Y)[_.moduleType]), q({
                    class: "thn--tool-note-component",
                    key: l,
                    "tool-kind": v(S).Note,
                    ref_for: !0
                  }, {
                    moduleProps: _
                  }), null, 16, ["tool-kind"]))), 128)),
                  G(W)
                ])
              ])
            ])
          ], 8, _t), [
            [J, !n.hidden]
          ])
        ];
      }),
      _: 1
    }, 8, ["name"]));
  }
}), bt = /* @__PURE__ */ rt(Tt, [["__scopeId", "data-v-b6b749d5"]]), wt = ["data-device"], Nt = /* @__PURE__ */ L({
  __name: "Note",
  props: {
    tool: {},
    context: {}
  },
  emits: [
    "hide",
    "hidden"
  ],
  setup(r, { expose: a, emit: t }) {
    const e = r, c = t, i = nt(K({
      ...e,
      toolKind: S.Note
    })), T = {
      [P.SlideIn]: I,
      [P.Bar]: bt
    }, f = D(!1), w = s(() => (e.tool, {
      ...e.tool.settings.layout
    })), n = s(() => e.tool.content.modules.find((l) => l.moduleType === B.Icon)), h = s(() => dt(e.tool.content.modules).filter(
      (k) => k.moduleType !== B.Icon
    )), o = s(() => {
      var k, V, A;
      if (!e.tool.settings.layout || !((V = (k = e.tool.settings) == null ? void 0 : k.layout) != null && V.type))
        return I;
      const l = (A = e.tool.settings.layout) == null ? void 0 : A.type;
      return T[l];
    });
    function u() {
      f.value = !1;
    }
    function m() {
      c("hide"), f.value = !0;
    }
    function _() {
      c("hidden");
    }
    return tt(() => {
      at(K({
        ...e,
        toolKind: S.Note
      }));
    }), ot(() => {
      i.handlers.callHandler(b.Show), e.tool.settings.timing.pagetime && setTimeout(() => {
        i.handlers.callHandler(b.Hide), m();
      }, Number(e.tool.settings.timing.pagetime) * 1e3);
    }), a({
      show: u,
      hide: m
    }), (l, k) => (d(), M("div", {
      "data-device": l.context.deviceViewport
    }, [
      o.value ? (d(), g(C(o.value), {
        key: 0,
        onAfterLeave: _,
        hidden: f.value,
        layout: w.value,
        "icon-props": n.value,
        "rest-modules": h.value,
        tool: l.tool,
        context: l.context
      }, null, 40, ["hidden", "layout", "icon-props", "rest-modules", "tool", "context"])) : H("", !0)
    ], 8, wt));
  }
});
export {
  Nt as _,
  Ct as d,
  $ as g,
  Y as n
};
//# sourceMappingURL=Note.vue_vue_type_script_setup_true_lang.Dkiikeda.js.map
